'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeStaticProps = undefined;

var _reactExtras = require('./reactExtras');

var _reactExtras2 = _interopRequireDefault(_reactExtras);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
}; /*
    * based on https://github.com/angus-c/es6-react-mixins/blob/master/src/mixin.js
    */

var REACT_PROPS = ['childContextTypes', 'contextTypes', 'defaultProps', 'propTypes'];
var REACT_LIFECYCLES = ['componentWillMount', 'componentDidMount', 'componentWillReceiveProps', 'componentWillUpdate', 'componentDidUpdate', 'componentWillUnmount', 'render'];

var es6ify = function es6ify(mixin) {
  if (typeof mixin === 'function') {
    // mixin is already es6 style
    return mixin;
  }
  return function (Base) {
    // mixin is old-react style plain object
    // convert to ES6 class

    var NewClass = function (_Base) {
      _inherits(NewClass, _Base);

      function NewClass() {
        _classCallCheck(this, NewClass);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(NewClass).apply(this, arguments));
      }

      return NewClass;
    }(Base);

    var clonedMixin = Object.assign({}, mixin);
    // move React props to NewClass's constructor
    upgradeReactProps(NewClass, clonedMixin);
    // merge React props defined as ES7 class static properties
    // mergeStaticProps(NewClass, clonedMixin);
    Object.assign(NewClass.prototype, clonedMixin);

    return (0, _reactExtras2.default)(NewClass);
  };
};

function mixin() {
  for (var _len = arguments.length, mixins = Array(_len), _key = 0; _key < _len; _key++) {
    mixins[_key] = arguments[_key];
  }

  return mixins.reduceRight(function (Klass, mixin) {
    return es6ify(mixin)(Klass);
  }, this);
}

function upgradeReactProps(klass, mixin) {
  var staticProps = REACT_PROPS.reduce(function (result, prop) {
    if (mixin[prop]) {
      klass[prop] = mixin[prop];
      delete mixin[prop];
    }
    return result;
  }, {});
  return klass;
}

function mergeStaticProps(klass, clonedMixin) {
  var superKlass = Object.getPrototypeOf(klass);
  var mixin = clonedMixin || superKlass;
  Object.keys(mixin).forEach(function (m) {
    if (typeof m !== 'function') {
      klass[m] = Object.assign(klass[m] || {}, mixin[m]);
    }
  });

  return klass;
}

exports.mergeStaticProps = mergeStaticProps;
exports.default = mixin;